<script>
import baseMixin from '@/mixins/baseMixin'
import BaseTreeSelector from '@components/general/base-tree-selector.vue'
import { mapActions, mapGetters } from 'vuex'
import objectSearch from '@utils/object-search'

export default {
  name: 'AdminSelector',
  components: { BaseTreeSelector },
  mixins: [baseMixin],
  model: {
    event: 'change',
    prop: 'selected',
  },
  props: {
    allowedAdminIds: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      getAdminTree: 'staff/getFlatAdminTree',
    }),
    treeData() {
      return this.getAdminTree.filter((n) =>
        this.allowedAdminIds.includes(n.id)
      )
    },
    selectedAdmin: {
      get() {
        return this.selected.map((adminId) =>
          objectSearch(this.treeData, adminId + '-Admin', 'key', 'children')
        )
      },
      set(val) {
        const selectedAdminIds = val.map((adminNode) => adminNode.id)
        this.$emit('change', selectedAdminIds)
      },
    },
  },
  async created() {
    await this.loadAdminTree()
  },
  methods: {
    ...mapActions({
      loadAdminTree: 'staff/loadFlatAdminTree',
    }),
    adminsSelected(adminNodes) {
      if (!adminNodes) return
      const adminIds = adminNodes.map((adminNode) => adminNode.id)
      this.$emit('save', adminIds)
    },
  },
}
</script>

<template>
  <BaseTreeSelector
    ref="tree"
    v-model="selectedAdmin"
    :tree-data="treeData"
    searchable
    selectable
    :title="$t('adminSelector.title')"
    @save="adminsSelected"
  >
  </BaseTreeSelector>
</template>
